import React from 'react';
import { AwardIcon, ShieldCheckIcon, HeartIcon } from 'lucide-react';
export const ExpertSection = () => {
  return <section className="w-full bg-white py-16 md:py-24" data-id="element-205">
      <div className="container mx-auto px-4 md:px-6" data-id="element-206">
        <div className="max-w-4xl mx-auto" data-id="element-207">
          <h2 className="text-2xl md:text-3xl font-bold text-center text-indigo-900 mb-8" data-id="element-208">
            Formulated by Sleep Experts
          </h2>
          <div className="bg-indigo-50 rounded-lg shadow-lg p-6 md:p-8 mb-12" data-id="element-209">
            <div className="flex flex-col md:flex-row items-center" data-id="element-210">
              <div className="md:w-1/2 mb-8 md:mb-0" data-id="element-211">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/rDSgktWeXTY7srwkSMpsM2/Screenshot_2025-08-25_at_10.20.19_PM.png" alt="Elizabeth and Harshada, Setu's In-house Nutritionists" className="rounded-lg shadow-md w-full" data-id="element-212" />
              </div>
              <div className="md:w-1/2 md:pl-8" data-id="element-213">
                <h3 className="text-xl font-bold text-indigo-900 mb-4" data-id="element-214">
                  Meet Our In-house Nutritionists
                </h3>
                <div className="mb-6" data-id="element-215">
                  <h4 className="font-bold text-indigo-800" data-id="element-216">
                    Elizabeth & Harshada
                  </h4>
                  <p className="text-gray-700 italic" data-id="element-217">
                    Sleep Science Specialists
                  </p>
                </div>
                <p className="text-gray-700 mb-4" data-id="element-218">
                  With combined expertise in nutritional biochemistry and sleep
                  science, Elizabeth and Harshada developed Sleep Restore strips
                  to address the root causes of sleep disruption.
                </p>
                <p className="text-gray-700 mb-6" data-id="element-219">
                  Their formulation focuses on supporting your body's natural
                  melatonin production while ensuring optimal absorption through
                  our innovative melt-in-your-mouth delivery system.
                </p>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-220">
                  <div className="flex items-start" data-id="element-221">
                    <ShieldCheckIcon className="h-5 w-5 text-indigo-600 mr-2 flex-shrink-0 mt-0.5" data-id="element-222" />
                    <p className="text-gray-700 text-sm" data-id="element-223">
                      Research-backed formulation
                    </p>
                  </div>
                  <div className="flex items-start" data-id="element-224">
                    <HeartIcon className="h-5 w-5 text-indigo-600 mr-2 flex-shrink-0 mt-0.5" data-id="element-225" />
                    <p className="text-gray-700 text-sm" data-id="element-226">
                      Focus on natural ingredients
                    </p>
                  </div>
                  <div className="flex items-start" data-id="element-227">
                    <AwardIcon className="h-5 w-5 text-indigo-600 mr-2 flex-shrink-0 mt-0.5" data-id="element-228" />
                    <p className="text-gray-700 text-sm" data-id="element-229">
                      Pharmaceutical-grade quality
                    </p>
                  </div>
                  <div className="flex items-start" data-id="element-230">
                    <ShieldCheckIcon className="h-5 w-5 text-indigo-600 mr-2 flex-shrink-0 mt-0.5" data-id="element-231" />
                    <p className="text-gray-700 text-sm" data-id="element-232">
                      Clinically-proven effectiveness
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
};